import { trackerGet } from '../client';

type DimensionList = { items: string[] };

type RangeParams = { from?: string; to?: string };

export function listLinkCountries(linkId: number, params: RangeParams = {}) {
  return trackerGet<DimensionList>(`/links/${linkId}/stats/countries`, params);
}

export function listLinkLanguages(linkId: number, params: RangeParams = {}) {
  return trackerGet<DimensionList>(`/links/${linkId}/stats/languages`, params);
}

export function listLinkDeviceTypes(linkId: number, params: RangeParams = {}) {
  return trackerGet<DimensionList>(`/links/${linkId}/stats/device-types`, params);
}

export function listTargetCountries(params: { target_url: string } & RangeParams) {
  return trackerGet<DimensionList>('/targets/stats/countries', params);
}

export function listTargetLanguages(params: { target_url: string } & RangeParams) {
  return trackerGet<DimensionList>('/targets/stats/languages', params);
}

export function listTargetDeviceTypes(params: { target_url: string } & RangeParams) {
  return trackerGet<DimensionList>('/targets/stats/device-types', params);
}
